import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElBadge = _resolveComponent("ElBadge")!

  return (_openBlock(), _createBlock(_component_ElBadge, _normalizeProps(_guardReactiveProps(_ctx.$props)), null, 16))
}